import logo from '../components/assets/logo.svg';

export function OnboardingConfirmationPage() {
  return (
    <div className="min-h-screen bg-[#7B1C14] py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-3xl mx-auto space-y-8">
        {/* Header Section */}
        <div className="text-center mb-8">
          <img 
            src={logo} 
            alt="Spicy Cubes" 
            className="h-16 sm:h-20 md:h-24 mx-auto"
          />
        </div>
        
        <div className="bg-[#6E1912] rounded-lg shadow-lg p-8">
          <div className="relative pb-6 mb-6 border-b border-[#F7E8CC]/10">
            <h1 className="text-3xl font-bold text-[#F7E8CC] text-center">Submission Successful!</h1>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-48 h-[2px] bg-gradient-to-r from-transparent via-[#F7E8CC]/10 to-transparent" />
          </div>

          <div className="space-y-4 text-center">
            <p className="text-[#F7E8CC]/80">
              Thank you for completing your onboarding information!
            </p>
            <p className="text-[#F7E8CC]/80">
              Please check your email for login details and next steps. If you don't receive an email within a few minutes, please check your spam folder.
            </p>
            <p className="text-[#F7E8CC]/80 mt-6">
              For questions or support please contact{' '}
              <a 
                href="mailto:ashli@spicycubes.co" 
                className="font-bold text-[#F7E8CC] hover:text-[#F7E8CC] whitespace-nowrap underline decoration-[2px] hover:decoration-[2.5px] transition-all duration-200 [text-decoration-skip-ink:none]"
              >
                ashli@spicycubes.co
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
} 